module.exports = __webpack_public_path__ + "img/double-line.6e461627.svg";